module.exports = __webpack_public_path__ + "img/icon-edit.33106907.svg";